import { render } from "./BlogPaperList.vue?vue&type=template&id=96d16d4a"
import script from "./BlogPaperList.vue?vue&type=script&lang=js"
export * from "./BlogPaperList.vue?vue&type=script&lang=js"

import "./BlogPaperList.vue?vue&type=style&index=0&id=96d16d4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__